<template>
    <div class="col-xl-3 col-lg-4 col-12">
        <div class="card">
          <div class="d-flex align-items-end row">
            <div class="col-7">
              <div class="card-body text-nowrap">
                <h5 class="card-title mb-0">Congratulations {{userStore.user.firstname}}! 🎉</h5>
                <p class="my-1">Welcome to Creditfixrr.</p>
                <a href="https://creditfixrr.com/academy/course/dealing-with-the-credit-bureaus" class="btn btn-primary waves-effect waves-light">Get Started</a>
              </div>
            </div>
            <div class="col-5 text-center text-sm-left" style="position: relative;">

            </div>
          </div>
        </div>
      </div>
</template>
<script>
import { useLocalizationStore } from '../../../stores/LocalizationStore.js'
import { useUserStore } from '../../../stores/UserStore.js'
import { openModal } from '../../../utilities/_helpers'
export default {
    components: {

    },
    setup() {
        return {
            localizationStore: useLocalizationStore(),
            userStore: useUserStore(),
            openModal: openModal,
        }
    },
}
</script>
